import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import { getPackage } from "../../../../redux/actions/apiActions";
import PackageListItem from "./PackageListItem";
import ChooseCarMobile from "components/common/ChooseCarMobile";
import { isMobile } from "react-device-detect";
import { gtm_ecommerce_viewItem_list } from "lib/GA4_tag";

const PackageList = ({
  setTypeOne,
  setServiceData,
  serviceData,
  show,
  id,
  setShow,
  handleShow,
  globalData,
  getCarBrandModal,
  apiData,
  getModel,
  getWorkshopFilterMap,
  variantId,
  cart,
  loginData,
  getPackage,
}) => {
  const [showDescription, setShowDescription] = useState(null);
  const [showMobileChooseCar, setShowMobileChooseCar] = useState(false);
  const [packages, setPackages] = useState([]);
  const router = useRouter();

  useEffect(() => {
    if (globalData.locationData?.data) {
      getPackage(
        globalData.locationData?.data.EmirateId,
        globalData.locationData?.data.EmirateAreaId,
        globalData.carData?.brandId || null,
        globalData.carData?.modelId || null,
        loginData.userAuth?.Id || null
      );
    }
  }, [globalData.locationData?.data, globalData.carData]);
  useEffect(() => {
    if (apiData && apiData?.packages && apiData?.packages?.length > 0) {
      const areArraysEqual =
        packages.length &&
        JSON.stringify(packages) === JSON.stringify(apiData?.packages);

      if (!areArraysEqual) {
        const items = apiData.packages.map((items, index) => {
          const filterCategory = apiData.categories?.filter(
            (item) => item.ID == 15
          );
          return {
            item_id: items.Id,
            item_name: items.Name,
            item_category: filterCategory[0].Name,
            item_list_id: filterCategory[0].ID,
            item_list_name: filterCategory[0].Name,
            price: items.Cost,
            index: index,
            quantity: 1,
          };
        });
        gtm_ecommerce_viewItem_list({ item_list_id: 15, items: items });
      }

      setPackages(apiData?.packages);
    }
  }, [apiData.packages]);
  return (
    <>
      <ChooseCarMobile
        show={showMobileChooseCar}
        setShow={setShowMobileChooseCar}
      />
      {!cart.loadingPackages && apiData.packages.length != 0 ? (
        apiData.packages != "" &&
        apiData.packages != null &&
        apiData.packages != undefined ? (
          <>
            {apiData.packages.map((variant, index) => {
              if (variant.Slug == router.query?.slug[1]) {
                return (
                  <Row key={index}>
                    <PackageListItem
                      setTypeOne={setTypeOne}
                      show={show}
                      id={id}
                      handleShow={handleShow}
                      getWorkshopFilterMap={getWorkshopFilterMap}
                      variant={variant}
                      getModel={getModel}
                      getCarBrandModal={getCarBrandModal}
                      showDescription={showDescription}
                      setShowDescription={setShowDescription}
                      showMobileChooseCar={showMobileChooseCar}
                      setShowMobileChooseCar={setShowMobileChooseCar}
                    />
                  </Row>
                );
              } else {
                return <></>;
              }
            })}

            {apiData.packages.map((variant, index) => {
              if (variant.Slug != router.query?.slug[1]) {
                return (
                  <Row key={index}>
                    <PackageListItem
                      setTypeOne={setTypeOne}
                      show={show}
                      id={id}
                      handleShow={handleShow}
                      getWorkshopFilterMap={getWorkshopFilterMap}
                      variant={variant}
                      getModel={getModel}
                      getCarBrandModal={getCarBrandModal}
                      showDescription={showDescription}
                      setShowDescription={setShowDescription}
                      showMobileChooseCar={showMobileChooseCar}
                      setShowMobileChooseCar={setShowMobileChooseCar}
                    />
                  </Row>
                );
              } else {
                return <></>;
              }
            })}
          </>
        ) : (
          <div></div>
        )
      ) : cart.loadingPackages ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeleton
            style={{ width: isMobile ? "95vw" : "55vw", height: "170px" }}
          />
          <Skeleton
            style={{ width: isMobile ? "95vw" : "55vw", height: "170px" }}
          />
          <Skeleton
            style={{ width: isMobile ? "95vw" : "55vw", height: "170px" }}
          />
        </div>
      ) : (
        <div className="package-list-empty px-1">
          {" "}
          <p>
            No service contract found for car model: {globalData.carData?.brand}
            -{globalData.carData?.modal}{" "}
          </p>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPackage: (
      EmirateId,
      EmirateAreaId,
      CarCompanyId,
      CarModelId,
      CustomerId
    ) => {
      dispatch(
        getPackage(
          null,
          null,
          null,
          CarModelId,
          null
          // EmirateId,
          // EmirateAreaId,
          // CarCompanyId,
          // CarModelId,
          // CustomerId
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageList);
